import { createContext } from "react";

export interface IParamsContext {
  boardId: string | undefined;
  runId: string | undefined;
}

export const ParamsContext = createContext({} as IParamsContext);
